var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.593 6.546c.248-.224.553-.373.881-.43L41.448.344a1.793 1.793 0 0 1 2.072 1.53l2.461 17.514a1.793 1.793 0 0 1-1.57 2.041l-33.287 3.54a1.77 1.77 0 0 1-.966-.17l-8.344-4.07A1.81 1.81 0 0 1 .82 19.35l-.702-4.996a1.81 1.81 0 0 1 .578-1.597z",
    clipRule: "evenodd"
  })));
};
export default SvgDiscount;